import { render, staticRenderFns } from "./cashRegisterSkeleton.vue?vue&type=template&id=237f14a4&scoped=true&"
import script from "./cashRegisterSkeleton.vue?vue&type=script&lang=js&"
export * from "./cashRegisterSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f14a4",
  null
  
)

export default component.exports